import PropTypes from "prop-types";
import Container from "solar/components/Container";
import Title from "components/shared/stays/Title";
import Text from "components/shared/stays/Text";
import CollectionCard from "components/shared/stays/CollectionCard";
import styles from "components/collections/List.module.scss";

export default function List({ collections }) {
  const sortedCollections = collections.sort((a, b) => b.id - a.id);

  return (
    <Container wide className={styles.component}>
      <Title size={3} tag="h1" className={styles.title}>
        Hand-picked collections
      </Title>
      <Text className={styles.copy}>
        Find daily discoveries recommended by surfers from around the world
      </Text>
      <div className={styles.grid}>
        {sortedCollections.map((collection) => (
          <CollectionCard
            key={collection.id}
            slug={collection.slug}
            name={collection.name}
            numTrips={collection.num_trips}
            imageUrl={collection.image?.url}
          />
        ))}
      </div>
    </Container>
  );
}

List.propTypes = {
  collections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      slug: PropTypes.string,
      num_trips: PropTypes.number,
      image: PropTypes.shape({
        url: PropTypes.string,
      }),
    })
  ).isRequired,
};
